module.exports = __webpack_public_path__ + "img/grid.5bf96254.svg";